
import React, {useRef} from 'react';

const SearchBar = ({ ref, onSearch, onGetLocation, isMobile, setSearchQuery, searchQuery}) => {
  return (
    <div className="dc-registerformgroup" >
      {/* Search input on the left */}
      <div className='form-group form-group-half'>
        <input className="form-control" ref={ref} placeholder="Search for a place" type="text"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSearch(ref);
              e.preventDefault(); // Prevent form submission
            }
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      
      {/* Buttons on the right */}
      <div className='form-group form-group-half'>
        <button
          type="button"
          onClick={onSearch}
          className='btn btn-primary'
        >
          Search
        </button>

        <button
          type="button"
          className='btn btn-primary'
          onClick={onGetLocation}
          style={{ float: 'right' }}
        >
          <img
            draggable="false"
            alt="📍"
            src="https://s.w.org/images/core/emoji/15.0.3/svg/1f4cd.svg"
            style={{ width: '16px', verticalAlign: 'middle', marginRight: '5px' }}
          />
          Current Location
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
